<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    {{message}}
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-button class="cancel-delete" (click)="onCancel()" [disabled]="isDeleting">
        {{cancelText}}
    </button>
    <button mat-button class="delete" (click)="deleteSelected()" [disabled]="isDeleting">
        {{isDeleting ? 'Eliminando...' : confirmText}}
    </button>
</mat-dialog-actions>